import { Component } from '@angular/core';

@Component({
  selector: 'splash-view',
  standalone: false,
  templateUrl: './splash-view.component.html',
  styleUrls: ['./splash-view.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
})
export class SplashViewComponent {}
